import get from "lodash/get";
import groupBy from "lodash/groupBy";
import sortBy from "lodash/sortBy";
import moment from "moment";
import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";

import Button from "@mui/material/Button";
import CalendarIcon from '@mui/icons-material/CalendarToday';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CustomTextField from "../common/CustomTextField";
import MyMessage from "./MyMessage";
import ResponseBubble from "./ResponseBubble";
import SchedulePatientButton from "../patients/SchedulePatientButton";
import {formatPatientName} from "../../helpers/patients";
import config from '../../config/config';
import BackButton from "../common/BackButton";
import useIsMobile from "../../hooks/useIsMobile";

import "./ViewMessageThreadScreen.scss";
const ViewMessageThreadScreen = (props) => {
  const isMobile = useIsMobile();
  const bottomRef = useRef();
  const navigate = useNavigate();
  const {user, otherUserId, messages, onMarkUnread, otherUser, text} = props;
  console.log('user', 'otherUser', user, otherUser);
  const messagesByDate = groupBy(
    sortBy(messages || [], (m) => new Date(m.date_sent)),
    (m) => moment(m.date_sent).format("M/D/yyyy")
  );
  const dateKeys = Object.keys(messagesByDate);
  const message = {
    message: text,
    user_to_id: otherUserId,
  };
  useEffect(() => {
    if (bottomRef) {
      const scrollHeight = bottomRef?.current?.scrollIntoView({
        behavior: "auto",
      });
    }
  }, [bottomRef]);
  return (
    <Stack className="ViewMessageThreadScreen" width={'100%'} sx={{
      paddingTop: {xs: '0', sm: '15px'}
    }}>
      <Stack direction="row" sx={{
        padding: {xs: '0', sm: '7px 0 0 8px'},
      }}>
        <BackButton variant="backButton"
          className="ViewMessageThreadScreen__back-button"
          sx={{
            flexDirection: 'row',
            textAlign: 'left',
            padding: 0,
            margin: {xs: '5px 0 20px 0', sm: 0}
          }}/>
      </Stack>
      <Paper className="ViewMessageThreadScreen-container"
             width={'100%'}
             flexDirection={'row'}
             sx={{
               borderRadius: '12px',
               marginTop: {xs: 0, sm: '32px'},
               padding: {xs: '5px 9px', sm: '4px 60px 0 60px'}
             }}>
        <Stack alignItems={'center'} marginBottom={'10px'}>
          <Typography flexDirection="row"
                      padding={'10px 0 10px 0'}
                      alignItems="center"
                      variant="largeSemiBoldLooseInter">
            {otherUser ? formatPatientName(otherUser) : ""}
          </Typography>
        </Stack>
        <Box className="message-history"
             margin={{xs: '10px 0 20px 0', sm: '30px 0 29px 0'}}
             sx={{gap: '17pxx'}}
             padding={0}>
          {dateKeys && dateKeys.length ? null : (
            <Box className="message-history__empty-message-box" paddingTop={'2em'}>
              <Typography
                variant="h2"
                align="center"
                color={config().colors.muted}
              >
                It looks like you haven't sent any messages yet.
              </Typography>
            </Box>
          )}
          {(dateKeys || []).map((k) => (
            <Stack key={k} className="message-history-block"
                   padding={'8px'}
                   paddingRight={{xs: '17px', sm: '0'}}
            >
              <Typography className="message-history-block-send-date"
                          marginRight={{xs: '12px', sm: 0}}
                          marginBottom='10px'
                          color='text.light'
                          variant="smallSemiBoldTightInter">
                {moment(get(messagesByDate, `[${k}][0].date_sent`)).format(
                  "ll"
                )}
              </Typography>
              {messagesByDate[k].map((m) =>
                user?.id === m?.user_from.id ? (
                  <MyMessage message={m}/>
                ) : (
                  <ResponseBubble message={m} onMarkUnread={onMarkUnread}/>
                )
              )}
              <div ref={bottomRef}/>
            </Stack>
          ))}
        </Box>
        <Stack className="ViewMessageThreadScreen__message-editor" gap={'10px'}>
          <CustomTextField
            class="ViewMessageThreadScreen__message-editor__text-field"
            type="textarea"
            multiline
            rows={4}
            value={text}
            disabled={props.isSubmitting}
            onChange={props.onChange}
          />
          <Container maxWidth='xs'>
            <Grid container spacing={1} padding={1} justifyContent='center'>
              <Grid item xs={12}>
                <Button
                  variant='contained'
                  size='small'
                  disabled={props.isSubmitting}
                  fullWidth
                  onClick={async () => {
                    const done = await props.onSendMessage({...message});
                    if (bottomRef.current) {
                      setTimeout(() => {
                        bottomRef?.current?.scrollIntoView({ behavior: "auto" });
                      }, 500);
                    }
                  }}
                >
                  Send
                </Button>
              </Grid>
              {props.isProvider ? 
                <Grid item xs={6}>
                  <div style={{width: '100%'}}>
                    <Button
                      variant='outlined'
                      size='small'
                      onClick={() => props.onViewPatientProfile()}
                      fullWidth={true}
                    >
                      View Profile
                    </Button>
                  </div>
                </Grid>
              : null}
              <Grid item padding={0} xs={props.isProvider ? 6 : 12}>
                  <div style={{width: '100%'}}>
                    {
                      props.isProvider
                      ? <SchedulePatientButton
                        color='primary'
                        variant='outlined'
                        size='small'
                        fullWidth
                        patientId={otherUser.id}
                      />
                      : <Button
                        color='primary'
                        variant='outlined'
                        size='small'
                        fullWidth
                        onClick={() => navigate(`/clients/appointments/new/${otherUser.id}`)}
                      >
                        <CalendarIcon style={{marginRight: '0.25em'}}/>
                        Schedule Now
                      </Button>
                    }
                  </div>
              </Grid>
            </Grid>
          </Container>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default ViewMessageThreadScreen;
